import {Component} from '@angular/core';

/**
 * A directive that logs the user out after 20 minutes and displays a 2 minute warning indicator beforehand.
 */
@Component({
  selector: 'ngb-progress-circle',
  template: `
      <div class="circular-indicator">
          <div class="circle1 circle"></div>
          <div class="circle2 circle"></div>
          <div class="circle3 circle"></div>
          <div class="circle4 circle"></div>
          <div class="circle5 circle"></div>
          <div class="circle6 circle"></div>
          <div class="circle7 circle"></div>
          <div class="circle8 circle"></div>
          <div class="circle9 circle"></div>
          <div class="circle10 circle"></div>
          <div class="circle11 circle"></div>
          <div class="circle12 circle"></div>
      </div>
  `,
  styleUrls: ['./progress-circle.scss']
})
export class NgbdProgressCircle {

}
